<template>
</template>

<script>
export default {
  props: {
    solicitacao: {required: true, type: Object}
  },
  created() {
    let solicitacao = this.solicitacao
    this.$emit('on-submit', solicitacao)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/LizaStep.vue